import { makeEnvironmentProviders } from '@angular/core'; import {
ApiConfiguration,
ApiConfigurationParams
} from './api-configuration'; export function
provideApi(params:
ApiConfigurationParams) { return makeEnvironmentProviders([ { provide:
ApiConfiguration, useValue: params } ]); }